<ng-template [ngIf]="inserimento">
<div class="col-sm-12 coldx" 
	[ngStyle]="{ 'display' : ( visibleToggleAssocia ? 'block' : 'none') }">
	<h4 *ngIf="title">{{title}}</h4>
	<form class="cerca_grey">
		<div class="row">
			<p class="col-sm-12">
				<label for="cerca-sez-ec-fndrsc-lbl">Cerca</label> <input id="cerca-sez-ec-fndrsc-lbl" type="text" #searchItem (keyup)="0"
					class="form-control" placeholder="Inserisci nome e cognome" />
			</p>
		</div>
	</form>
	<ng-template [ngIf]="legaliAll.length > 0">
	<ul id="controparticollapse" class="controparti">

		<ng-template ngFor let-legaleIncaricato [ngForOf]="legaliAll  | searchFilter : searchItem.value : 'legale.nominativo' ">

		<li class="panel">
			<div class="controparte">
				<div>
					<p class="col-xs-12 col-sm-2">
						<button class="btn btn-primary associa"
							(click)="associaLegale(legaleIncaricato);" type="submit">Associa</button>
					</p>
						<h4 class="titolo col-sm-4">{{ legaleIncaricato.legale?.nominativo }}</h4>
					<ng-template [ngIf]="legaleIncaricato.legale?.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
						<p class="col-sm-4">
							C/F: <strong> {{ legaleIncaricato.legale?.codiceFiscale }} </strong>
						</p>
					</ng-template>
					<ng-template
						[ngIf]="legaleIncaricato.legale?.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
						<p class="col-sm-4">
							P.IVA: <strong> {{ legaleIncaricato.legale?.partitaIva }} </strong>
						</p>
					</ng-template>

					<p class="col-sm-2 matricola">
						<strong>{{legaleIncaricato?.categoriaLegaleIncaricato.label}}</strong>
					</p>
				</div>
			</div>
		</li>
		</ng-template>
	</ul>
	</ng-template>
	<ng-template [ngIf]="legaliAll.length == 0">
	<p>Non esistono beneficiari da associare</p>
	</ng-template>
</div>
</ng-template>

<ng-template [ngIf]="fondoOneriForm">
<div class="col-sm-12 coldx"  [ngStyle]="{ 'display' : ( visibleToggleForm ? 'block' : 'none') }">
	<h4>{{title}}</h4>
	<form [formGroup]="fondoOneriForm" (ngSubmit)="save();">

		<div class="row">

				<ng-template [ngIf]="!inserimento"><div comboModInput class="col-sm-6" [labelInput]="'Legale'"
					formControlName="legaleIncaricato" [labelOption]="'legale.nominativo'"
					[(ngModel)]="request.legaleIncaricato" [objectReference]="request.legaleIncaricato"
					[control]="fondoOneriForm.controls['legaleIncaricato']"
					[mandatory]="true" (onReturn)="request.legaleIncaricato = $event"
					[optionsCombo] ="legaliOptions"></div>
				</ng-template>

				<ng-template [ngIf]="inserimento && request.legaleIncaricato?.legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">

				<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Cognome e nome'"
				[valueInput]="request.legaleIncaricato?.legale.nominativo"></div>

				<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Tipo Legale'"
				[valueInput]="request.legaleIncaricato?.categoriaLegaleIncaricato.label"></div>

				</ng-template>

				<ng-template [ngIf]="inserimento && request.legaleIncaricato?.legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">

				<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Ragione sociale'"
				[valueInput]="request.legaleIncaricato?.legale.ragioneSociale"></div>

				<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Tipo Legale'"
				[valueInput]="request.legaleIncaricato?.categoriaLegaleIncaricato.label"></div>

				</ng-template>

		</div>
		<div class="row">

			<div comboModInput [control]="fondoOneriForm.controls['tipoFase']"
				class="col-sm-3" [labelInput]="'Tipo fase'"
				formControlName="tipoFase"	[objectReference]="request.tipoFase"
				(onReturn)="request.tipoFase = $event"
				[optionsCombo] ="tipoFaseOptions" [mandatory]="true"
				[(ngModel)]="request.tipoFase"></div>

			<div naturalNumberInput [control]="fondoOneriForm.controls['anno']"
				class="col-sm-3" [labelInput]="'Anno'" [maxLength]="'4'"
				formControlName="anno" [checkFormat]="true"
				[(ngModel)]="request.anno" [mandatory]="true"></div>

			<div comboModInput class="col-sm-3" [labelInput]="'Mese'"
				formControlName="mese"	[objectReference]="meseAdapter"
				(onReturn)="meseAdapter = $event" [optionsCombo] ="meseOptions"
				[location]="'mesi'"
				[(ngModel)]="meseAdapter"></div>

				<div textInputCurrency class="col-sm-3" [control]="fondoOneriForm.controls['importo']"
				[labelInput]="'Importo'" [location]="'SezioneEconomica'" [mandatory]="true"
				formControlName="importo" [(ngModel)]="request.importo"></div>

		</div>

		<div class="row">
			<div textAreaInput class="col-sm-12" [labelInput]="'Nota'"
				formControlName="nota" [(ngModel)]="request.nota"></div>
		</div>

		<div class="row">
			<p class="mandatory col-sm-12">
				<em>* Campi obbligatori</em>
			</p>
		</div>
		<div class="row">
			<p class="col-sm-3 col-xs-6">
			<ng-template [ngIf]="inserimento">
			<button type="button" (click)="goToAssocia();"
				class="btn btn-outline-secondary btn-block">Indietro</button>
			</ng-template>
			<ng-template [ngIf]="!inserimento">
			<button type="button" class="btn btn-outline-secondary btn-block"
				(click)="createForm();">Reset</button>
			</ng-template>
			</p>
			<div class="col-sm-3 col-xs-6 col-sm-offset-6">
				<p submitButton [labelButton]="'Salva'" [disabled]="!fondoOneriForm.valid ||
																	!request.legaleIncaricato ||
																	!request.anno ||
																	( meseAdapter ? meseAdapter.id == -1 : true )"></p>
			</div>
		</div>
	</form>

</div>
</ng-template>
